import { n_lesson } from '../../../../ringle-student/modules/i18n/strings/auto/wording'
import { useStudentClassroom } from '../../../modules/apis/student/classroom'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useTranslation from '../../../modules/i18n/useTranslation'
import StudentClassroomBody from '../../student/new-portal/classroom/StudentClassroomBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

const LessonClassroomActivity = ({ params }) => {
  const { t } = useTranslation()
  const appRouter = useAppRouter()
  const { data, isFetching, error } = useStudentClassroom(params.lessonId as string)

  console.log('data', data)
  console.log('params.lessonId', params.lessonId)
  return (
    <WebviewStackContainer title={t(n_lesson.title)} height="54px" onBack={() => appRouter.back()}>
      {data && <StudentClassroomBody json={data} />}
    </WebviewStackContainer>
  )
}

export default LessonClassroomActivity
